import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Same helper as the Polaris kit's src/lib/utils.js: joins class lists and lets the last
// conflicting Tailwind class win (so a `class` prop can override). Differs from the kit's own
// `cn` (plain `twMerge`) because this app's Tailwind config adds scale keys twMerge's default
// config doesn't know about, and would otherwise misclassify:
// - `rounded-polaris-sm|md|lg|xl` (this app's radius scale, `theme/polaris-colors.js`'s
//   `polarisRadius`, plugged in via `tailwind.config.js`'s `theme.extend.borderRadius`) — without
//   this, twMerge doesn't recognize them as border-radius at all, so a plain caller `rounded-md`/
//   `rounded-full` never removes the kit's own `rounded-polaris-md` (Task 3 review, 2026-09-25).
// - `text-xxs` (this app's one added font-size step, `tailwind.config.js`'s `theme.fontSize`) —
//   without this, twMerge reads it as a text *color* (its default font-size validator only
//   recognizes `base`/t-shirt sizes/arbitrary lengths) and drops a kit text-color class next to it.
// - the app's named type styles (`text-body-main`, `text-heading-1`, `text-label-small`, ... — defined
//   in `assets/scss/_woot.scss`'s `@layer utilities`, the full list below): same misreading, so
//   `cn(buttonVariants(), 'text-body-main')` used to drop the kit's `text-polaris-primary-foreground`.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      borderRadius: ['polaris-sm', 'polaris-md', 'polaris-lg', 'polaris-xl'],
    },
    classGroups: {
      'font-size': [
        {
          text: [
            'xxs',
            'body-main',
            'body-para',
            'heading-1',
            'heading-2',
            'heading-3',
            'label',
            'label-small',
            'button',
            'button-small',
          ],
        },
      ],
    },
  },
});

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
